import { Component, OnInit } from '@angular/core';
import { RegistrationService } from 'src/app/administration/registrations/registration.service';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { SessionService } from '../../services/session.service';
import { PaymentType } from '../../models/payment-type-enum';
import { MatDialogRef } from '@angular/material/dialog';
import { OutingIterationInvoiceService } from 'src/app/administration/outings/outing-iteration-invoice/outing-iteration-invoice-service';
import { Registration } from 'src/app/administration/registrations/registration';

@Component({
    selector: 'stripe-refund-modal',
    templateUrl: './stripe-refund-modal.component.html',
    styleUrl: './stripe-refund-modal.component.scss',
    standalone: false
})
export class StripeRefundModalComponent extends BaseModalComponent implements OnInit {
  private invoice: any;

  public title: string;
  public body: string;
  public paymentType: PaymentType;
  public registration: Registration;
  public refundReason: string = '';

  constructor(private registrationService: RegistrationService,
    private outingIterationInvoiceService: OutingIterationInvoiceService,
    private sessionService: SessionService,
    public dialogRef: MatDialogRef<StripeRefundModalComponent>) {
    super();
  }

  ngOnInit(): void {
    this.getInvoices();
  }

  getInvoices() {
    this.isLoading = true;
    this.outingIterationInvoiceService.getByIteration(this.sessionService.getGlobalOutingIteration().id).subscribe({
      next: (result) => {
        this.invoice = result;
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        console.log(err);
      }
    });
  }

  refund() {
    if (this.paymentType === PaymentType.CashCheck) {
      let data = {
        cashGolfers: this.invoice.cashGolfers - 1,
        outingIterationId: this.sessionService.getGlobalOutingIteration().id,
        lastEditedBy: this.sessionService.getUserId()
      };
      this.outingIterationInvoiceService.update(this.invoice.id, data).subscribe({
        next: (result) => {
          if (result) {
            this.dialogRef.close({ status: 'success', message: 'Cash refund was successful' });
          }
          this.isLoading = false;
        },
        error: (err) => {
          console.log(err);
          this.isLoading = false;
        }
      });
    } else {
      let refundData = {
        stripeAccountId: this.sessionService.getUser().stripeAccountId,
        registrationUpdateModel: this.registration
      };      
      refundData.registrationUpdateModel.hasPaid = false;
      refundData.registrationUpdateModel.refundAmount = this.registration.cost;
      refundData.registrationUpdateModel.refundReason = this.refundReason || 'Refunded by Admin';
      refundData.registrationUpdateModel.lastEditedBy = this.sessionService.getUserId();
      this.isLoading = true;
      this.registrationService.refundPayment(refundData).subscribe({
        next: (result) => {
          this.dialogRef.close({ status: 'success', message: 'Refund was successful' });
        },
        error: (err) => {
          console.log(err);
          this.isLoading = false;
        }
      });
    }
  }
}
